import styled from 'styled-components'

import ButtonWithConfirmation from '~/components/button-with-confirmation/button-with-confirmation.component'
import { color } from '~/styles/utils'

export const ResetButton = styled(ButtonWithConfirmation).attrs({
  type: 'plain',
})`
  && {
    padding-top: 8px;
    padding-right: 0;
  }
`

export const Flex = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`

export const HeaderContainer = styled.div<{
  $greyOut: boolean
}>`
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
  position: relative;
  cursor: pointer;
  line-height: 1.5;

  opacity: ${({ $greyOut }) => ($greyOut ? '0.5' : '1')};

  &:before {
    position: absolute;
    content: '';
    left: 0;
    top: 23px;
    right: 0;
    border-top: ${({ $greyOut }) => ($greyOut ? '1px solid black' : 'none')};
    margin-right: 35px;
  }
`

export const CreditName = styled.div`
  color: ${color('black')};
  font-size: 18px;
  width: 100%;
`

export const CreditPassName = styled.div`
  color: ${color('black')};
  font-size: 14px;
  line-height: 0.9;
  cursor: pointer;
`

export const CreditAmount = styled.span`
  color: ${color('black')};
  font-size: 18px;
  margin-right: 5px;
`

export const CreditCurrency = styled.span`
  vertical-align: text-top;
  font-size: 12px;
  line-height: normal;
`

export const CreditValueWrapper = styled.span`
  margin-right: 18px;
`

export const CreditDetailWrapper = styled.div<{
  disableCreditDetailsBackground?: boolean
}>`
  ${({ disableCreditDetailsBackground }) =>
    !disableCreditDetailsBackground && 'background-color: #f4f4f4'};
  padding: 2px 35px 2px 20px;
  margin-top: 10px;
`

export const CreditDetailLine = styled.div`
  color: ${color('darkGrey')};
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  margin: 5px 0;
`

export const CreditDetailHeading = styled.span`
  display: inline-block;
`

export const NoWrap = styled.div`
  white-space: nowrap;
`
